import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertModule} from 'ngx-bootstrap/alert';
import {EmailSmsTemplateComponent} from "./email-sms-template.component";
import {FormsModule} from "@angular/forms";
import {EmailSmsPreviewModalModule} from "../../components/email-sms-preview-modal/email-sms-preview-modal.module";
import {EmailSmsPlaceholderModalModule} from "../../components/email-sms-placeholder-modal/email-sms-placeholder-modal.module";
import {CharacterLimitModule} from "../../components/character-limit/character-limit.module";
import {NgSelectModule} from "@ng-select/ng-select";
import {RouterModule} from '@angular/router';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import { BannerModule, ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [
    EmailSmsTemplateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    EmailSmsPreviewModalModule,
    EmailSmsPlaceholderModalModule,
    NgSelectModule,
    AlertModule,
    RouterModule,
    AlertMessageModule,
    CharacterLimitModule,
    BsDropdownModule.forRoot(),
    BannerModule,
    ButtonModule
  ],
  exports: [EmailSmsTemplateComponent],
  bootstrap: [EmailSmsTemplateComponent]
})
export class EmailSmsTemplateModule { }
